import React from 'react';
import {motion} from 'framer-motion';

const HowItWorks=({openCheckoutPopup})=> {
  const steps=[
    {
      number: 1,
      title: "Purchase the eBook for ₹97",
      description: "Secure payment with instant access",
      icon: "💳"
    },
    {
      number: 2,
      title: "Get instant download + bonus access",
      description: "Everything delivered to your email immediately",
      icon: "📧"
    },
    {
      number: 3,
      title: "Follow the workshop & start automating your sales",
      description: "Implement strategies and watch your income grow",
      icon: "🚀"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Start in Just <span className="gradient-text">3 Simple Steps</span>
            ⚙️
          </h2>
          <p className="text-lg text-gray-600">
            It's that easy to transform your business
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index)=> (
            <motion.div
              key={index}
              className="text-center"
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.2}}
              viewport={{once: true}}
            >
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-orange-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl">{step.icon}</span>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-orange-400 text-white rounded-full flex items-center justify-center font-bold">
                  {step.number}
                </div>
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2">
                  <div className="text-3xl text-gray-300">→</div>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.8}}
          viewport={{once: true}}
        >
          <button 
            onClick={openCheckoutPopup}
            className="glow-button text-white px-8 py-4 rounded-xl font-bold text-lg"
          >
            Get Instant Access for ₹97 →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;